import http from "../HttpService";

const controller = "/insurance/fe/";

function getUrl() {
  return `${controller}${http.GUID}`;
}

export function getData() {
  return http.get(getUrl());
}
